import ResourceApi from '../ResourceApi';

const UserReviewDateResource = {
  index: async (userId, params = {}) => (await ResourceApi.get(`/resource/users/${userId}/review-dates`, params)).data,
};

export default UserReviewDateResource;
